<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useDisconnectWallet } from '@/composables/game/wallet-connect'

defineProps<{
  show: boolean
}>()
const emit = defineEmits(['hide'])

const { disconnectWallet, isDisconnecting } = useDisconnectWallet()

async function _disconnectWallet() {
  await disconnectWallet()
  emit('hide')
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    @hide="$emit('hide')"
  >
    <div class="w-full flex flex-col items-center">
      <img
        src="@/assets/images/gifs/money.gif"
        class="w-[120px] h-[120px] min-w-[120px]"
      >
      <div class="mt-6 text-light-white uppercase text-2xl text-center font-bold -tracking-[0.48px]">
        <T
          key-name="wallet.confirm_disconnect"
          default-value="Confirm wallet disconnect"
        />
      </div>
      <div class="mt-8 flex flex-col gap-y-3 w-full">
        <BaseButton
          class="w-full"
          :loading="isDisconnecting"
          @click="_disconnectWallet"
        >
          <T
            key-name="wallet.disconnect"
            default-value="Disconnect"
          />
        </BaseButton>
        <BaseButton
          class="w-full"
          style-type="tertiary"
          @click="$emit('hide')"
        >
          <T
            key-name="generic.cancel"
            default-value="Cancel"
          />
        </BaseButton>
      </div>
    </div>
  </TheBottomSheet>
</template>

<style scoped>

</style>